import { render, staticRenderFns } from "./StylesMenu.vue?vue&type=template&id=6bf3cb70&"
import script from "./StylesMenu.vue?vue&type=script&lang=js&"
export * from "./StylesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports